import { styled } from "styled-components";

import { minWidth } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const Featured = styled.div`
    ${redundantCssFromKebab("display", "none")}
    @media ${minWidth.lg} {
        ${redundantCssFromKebab("display", "block")}
        ${redundantCssFromKebab("padding-bottom", "1rem")}
    }
`;

export const Grid = styled.div`
    ${redundantCssFromKebab("margin", "0 auto")}
    ${redundantCssFromKebab("max-width", "100%")}
    ${redundantCssFromKebab("padding", "0 1rem")}
    
    @media (min-width: 576px) {
        max-width: 540px;
    }

    @media (min-width: 768px) {
        max-width: 720px;
    }

    @media (min-width: 992px) {
        max-width: 960px;
    }

    @media (min-width: 1200px) {
        max-width: 1140px;
    }

    @media (min-width: 1400px) {
        max-width: 1320px;
    }

    > div {
        ${redundantCssFromKebab("display", "grid")}
        ${redundantCssFromKebab("gap", "2rem")}
        @media ${minWidth.sm} {
            ${redundantCssFromKebab(
                "grid-template-columns",
                "repeat(2, minmax(0, 1fr))"
            )}
        }
        @media ${minWidth.md} {
            ${redundantCssFromKebab(
                "grid-template-columns",
                "repeat(3, minmax(0, 1fr))"
            )}
        }
    }
`;

export const More = styled.div`
    ${redundantCssFromKebab("padding-top", "3rem")}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("justify-content", "center")}
`;

export const Section = styled.section`
    ${redundantCssFromKebab("padding-bottom", "2rem")}

    .noSearchResults {
        ${redundantCssFromKebab("margin", "0 auto")}
        ${redundantCssFromKebab("max-width", "40rem")}
        ${redundantCssFromKebab("text-align", "center")}

        img {
            ${redundantCssFromKebab("margin", "0 0 3rem")}
        }

        p {
            ${redundantCssFromKebab("margin", "0 0 0.5rem")}
        }
    }

    h2 span {
        &::before {
            ${redundantCssFromKebab("content", '" ("')}
        }

        &::after {
            ${redundantCssFromKebab("content", '")"')}
        }
    }
`;
